export default {
  nav: { title: '卦簽', historyTitle: '最近搖籤記錄' },
  levelName: { upper: '上籤', middle: '中籤', lower: '下籤' },
  fortune: {
    '大吉': '大吉', '吉': '吉', '中吉': '中吉', '平': '平',
    '中平': '中平', '小波折': '小波折', '需谨慎': '需謹慎', '需转变': '需轉變',
  },
  luckyColors: {
    '金黄色': '金黃色', '朱红色': '朱紅色', '天蓝色': '天藍色', '翡翠绿': '翡翠綠',
    '紫罗兰': '紫羅蘭', '珍珠白': '珍珠白', '琥珀色': '琥珀色', '玫瑰金': '玫瑰金',
    '深藏青': '深藏青', '橙红色': '橙紅色', '土黄色': '土黃色', '银白色': '銀白色',
    '大红色': '大紅色', '深蓝色': '深藍色', '墨绿色': '墨綠色', '米白色': '米白色',
    '棕褐色': '棕褐色', '翠绿色': '翠綠色', '深绿色': '深綠色', '紫色': '紫色',
    '金白色': '金白色', '金红色': '金紅色', '米黄色': '米黃色', '白色': '白色',
    '黑白相间': '黑白相間', '绿色': '綠色',
  },
  directions: {
    '东方': '東方', '南方': '南方', '西方': '西方', '北方': '北方',
    '东南方': '東南方', '西南方': '西南方', '东北方': '東北方', '西北方': '西北方',
    '正中': '正中', '东偏南': '東偏南', '正南': '正南', '中央': '中央',
  },
  keywords: {
    '顺畅': '順暢', '机遇': '機遇', '进取': '進取', '稳健': '穩健', '积累': '積累',
    '踏实': '踏實', '转机': '轉機', '调整': '調整', '智慧': '智慧', '和谐': '和諧',
    '平衡': '平衡', '中道': '中道', '成长': '成長', '磨砺': '磨礪', '坚持': '堅持',
    '圆满': '圓滿', '感恩': '感恩', '珍惜': '珍惜', '创新': '創新', '突破': '突破',
    '胆识': '膽識', '内修': '內修', '沉稳': '沉穩', '深藏': '深藏', '善缘': '善緣',
    '贵人': '貴人', '助力': '助力', '简化': '簡化', '本质': '本質', '清明': '清明',
    '生机': '生機', '丰盛': '豐盛', '开泰': '開泰', '腾飞': '騰飛', '鼎盛': '鼎盛',
    '把握': '把握', '福气': '福氣', '喜事': '喜事', '吉祥': '吉祥', '顺势': '順勢',
    '借力': '借力', '方向': '方向', '德行': '德行', '善念': '善念', '福报': '福報',
    '蜕变': '蛻變', '重生': '重生', '双喜': '雙喜', '连连': '連連', '大吉': '大吉',
    '归心': '歸心', '自然': '自然', '韧性': '韌性', '等待': '等待', '守正': '守正',
    '谨慎': '謹慎', '静守': '靜守', '内观': '內觀', '初心': '初心', '中庸': '中庸',
    '适度': '適度', '沉稳2': '沉穩', '蓄力': '蓄力',
  },
  advices: {
    upper: [
      '順勢而為，把握當下，好運正在向你奔來。',
      '心中有光，腳下有路，此時正是行動的好時機。',
      '內外兼修，以誠待人，福氣自然與你相隨。',
    ],
    middle: [
      '靜心等待，時機未到時的沉穩，是最好的準備。',
      '踏實做好每一件小事，積累的力量會在某天讓你驚喜。',
      '不急不躁，順應自然的節奏，水到自然渠成。',
    ],
    lower: [
      '此階段是調整的時機，內觀自省，往往能找到意想不到的出路。',
      '困境是成長的土壤，以平和的心態面對，每一次挑戰都是禮物。',
      '命理是認識自我的工具，而非束縛命運的枷鎖——調整方向，前路依然寬廣。',
    ],
  },
  banner: {
    subtitle: '心誠則靈，誠心問卜',
    disclaimer: '命理是認識自我的工具，非束縛命運的枷鎖',
  },
  intro: {
    title: '何為卦籤問卜',
    badge: '新手必讀',
    desc: '卦籤源自中國寺院的求籤文化，已有上千年歷史。信眾搖動籤筒，抽出一支籤詩，依據上籤、中籤、下籤三級，結合籤詩意境為進退兩難之事提供第三視角。它是參考框架，而非命定的判決。',
    step0: '誠心默想你所問之事，保持內心平靜',
    step1: '點擊籤筒搖籤，取第一根籤為準',
    step2: '結合籤詩與籤級，獲得方向性的指引',
  },
  input: { placeholder: '默想您的問題，誠心求籤（可選）' },
  tube: { shaking: '誠心搖籤中…', click: '點擊搖籤' },
  btn: { shake: '搖籤問卜', reshake: '再次搖籤', shaking: '誠心搖籤中···' },
  result: {
    share: '分享籤文結果',
    showPoem: '查看籤詩白話解讀',
    hidePoem: '收起解讀',
    showDeepReading: '查看詳細解讀（約500字）',
    hideDeepReading: '收起詳細解讀',
    poemTitle: '籤詩白話解讀',
    symbolLabel: '籤文意象',
    luckyLabel: '吉祥參考',
    luckyNumber: '數字 {{num}}',
    keywordLabel: '籤文關鍵詞：',
    detailTitle: '各方面詳析',
    detailHint: '點擊展開深度解讀',
  },
  detailItems: { love: '感情', career: '事業', wealth: '財運', health: '健康' },
  noResult: {
    guideTitle: '求籤須知',
    guide0: '保持誠心與平靜，是求籤的第一步。',
    guide1: '在心中默念您希望了解的問題，越清晰越好。',
    guide2: '點擊籤筒，誠心搖籤，取第一根為準。',
    guide3: '籤文是參考，智慧在自身，順勢調整才是真諦。',
    levelTitle: '籤文說明',
    level0Name: '上籤',
    level0Desc: '運勢向好，諸事皆宜，是順勢而為的好時機。',
    level1Name: '中籤',
    level1Desc: '運勢平穩，守正待時，踏實前行自然水到渠成。',
    level2Name: '下籤',
    level2Desc: '提示調整方向，困境中自有優化參考，內觀自省便是出路。',
  },
  warmth:
    '卦籤為傳統民俗文化，籤文僅供參考。當前內容資訊僅供娛樂使用，不等於專業測評，不代表價值評判，無任何現實指導意義，僅供娛樂參考。',
  footer:
    '卦籤為傳統民俗文化，當前內容資訊僅供娛樂使用，不等於專業測評，不代表價值評判，無任何現實指導意義，僅供娛樂參考。',
  card: { analysis: '深度解析', action: '行動建議', remedy: '優化參考' },

  resultBlocks: {
    toolBadgePoemSymbol: '籤詩象徵',
    layer1: '① 核心判斷',
    layer2: '② 推導依據（籤詩象徵層）',
    layer3: '③ 當前傾向（問題適配層）',
    layer4: '④ 風險邊界',
    layer5: '⑤ 行動建議',
    layer6: '⑥ 不確定性說明',
    boundaryJudgment: '邊界判定：',
    sigIntensity: '籤意強度',
    algoConfidence: '演算法置信度',
    qianyiCoreJudgment: '籤義核心判斷（問題適配主導）',
    qianyiConfidenceLabel: '籤意置信度',
    qianyiConfidenceShort: '籤意置信',
    derivationLink: '推導鏈路',
    viewFullDerivation: '查看完整推導路徑（{{steps}}步）',
    symbolExtractionPath: '象徵提取路徑',
    levelCompatibilityJudgment: '籤級兼容性判定',
    weightedFortune: '加權運勢',
    scoreSuffix: '分',
    promotionBoost: '提權增強',
    demotionWarning: '降權提示',
    neutralMatch: '中性匹配',
    sigPromotion: '籤義提權',
    sigDemotion: '籤義降權',
    adaptJudgmentDriver: '適配判斷 → 主結論第一驅動力（{{level}}）',
    highFit: '高契合',
    mediumFit: '中等契合',
    lowFit: '低契合',
    fitLevelLabel: '契合度',
    fitLevelHigh: '高',
    fitLevelMid: '中',
    fitLevelLow: '低',
    sigWeightedOnIssue: '象徵對此問題有加權',
    sigDemotedOnIssue: '象徵對此問題有降權',
    randomLayer: '隨機層',
    randomLayerDesc: '籤號由時間種子經LCG演算法生成，再加入問題類別偏移量——兩者都是確定性演算法，每次獨立運行',
    ruleLayer: '規則層',
    ruleLayerDesc: '籤級（上/中/下）→ 籤詩象徵提取 → 對當前問題類別的象徵提權/降權 → 現實意義映射，全程遵循傳統籤詩體系規則',
    referenceLayer: '參考層',
    referenceLayerDesc: '問題適配判斷（契合度高/中/低）、各方面解讀、行動建議——這些是籤意對問題的方向性參考，不是具體事件的預言',
    stableJudgment: '穩定判斷',
    stableJudgmentHigh: '此籤為精雕籤且籤詩象徵與問題方向高度契合，本次判讀依據較為充分，可作為內省方向參考',
    stableJudgmentMedium: '籤意與問題方向基本相符，核心判斷可作為參考，建議配合實際情況綜合判斷',
    stableJudgmentLow: '無具體問題輸入或籤意與問題關聯度較低，以綜合運勢方向為主，針對性相對有限',
    ruleDerivation: '規則推導',
    ruleDerivationDesc: '籤級/象徵映射',
    randomLayerShort: '隨機層',
    randomLayerShortDesc: '時間種子+問題偏移',
    referenceOnly: '僅參考',
    referenceOnlyDesc: '非命運預言',
    emotionalTitle: '寫給求籤的你',
    letterTitle: '寫給你的話',
    letterUpper: '關於「{{question}}」，你拿到了一支上籤。\n\n籤詩開篇寫道：「{{poemLine1}}，{{poemLine2}}」。這兩句詩不是在勸你躺平等好運，它真正想說的是——世間萬事都有自己的節律，當節律正好和你當下的方向對齊，事情推進起來會比平時省力許多。就像詩裡說的「{{poemSymbol}}」，呈現的是一種生機正旺、順勢可成的狀態。\n\n{{poemMeaning}}\n\n放在你的問題「{{question}}」上，這支上籤給出的參考，不是「你一定會成」，而是「這個階段，你為這件事準備和付出的那些，正在進入被看見、有回響的窗口」。你為這件事攢下的認真，那些反覆權衡的夜晚，那些不確定時依然選擇往前的時刻——它們沒有白費，只是在等一個讓它們得以落地的時機。而現在，恰好就是這個時機。\n\n上籤不是讓你停止努力，而是讓你停止過度懷疑。不必再反覆問「我準備好了嗎」，該做的你早已做了；現在要做的，是相信這份準備，把它放到對的風口上，然後走下去。\n\n願這段時光裡的每一步，都踩在你自己鋪好的路上。願你想要的，都在對的時候如約而至。前路漫漫，且行且寬心。祝好。',
    letterMiddle: '關於「{{question}}」，你拿到了一支中籤。\n\n籤詩裡寫道：「{{poemLine1}}，{{poemLine2}}」。這兩句詩的氣質，就像一位沉穩的長輩在你身邊，不急，不催，只是如實告訴你：現在的路線是對的，但要讓事情真正動起來，還差一點火候。詩中「{{poemSymbol}}」所描繪的意象，正是這種「將成未成、蓄勢待發」的狀態。\n\n{{poemMeaning}}\n\n回到你問的「{{question}}」——中籤給的不是一個好消息，也不是一個壞消息，而是一個誠實的提醒：你走的方向沒有偏，你付出的努力沒有錯方向，只是目前還差那麼一點點，讓這件事從「進展中」變成「真正成了」。\n\n那「一點點」究竟是什麼？只有你自己最清楚——也許是時機還沒到，也許是某件事還沒完全準備好，也許是某句話還沒說出口，也許只是還需要再多等一段。中籤不會替你把答案填上，但它輕輕指著那個方向說：那裡，還有一個你可以去完善的地方。\n\n找到那一點，補上它，然後繼續往前。籤裡說的「{{poemLine1}}」，意思就是：只要根紮住了，流向自然形成，結果終會到來。\n\n願你的付出在對的時候被看見。願那差的一點，成為你下一段路最紮實的起點。且行且穩心。祝好。',
    letterLower: '關於「{{question}}」，你拿到了一支下籤。心裡多少會沉一下——這很正常，我們都會這樣。\n\n但請先停下來，聽一聽這支籤真正想說的是什麼。\n\n籤詩開頭寫道：「{{poemLine1}}，{{poemLine2}}」。這兩句不是在宣判你，它描繪的是「{{poemSymbol}}」——那種看似險峻、實則指向調整與轉機的狀態。{{poemMeaning}}\n\n下籤在「{{question}}」這件事上想提醒你的，不是「這條路走不通了」，而是：你現在走的這條路，可能有些你還沒完全看清楚的地方。也許是時機上的錯位，也許是方式上還有更合適的選擇，也許是某個環節的準備還不夠充分。下籤像一盞燈，它照出的不是你的失敗，而是你還沒走進去看清楚的那個角落。\n\n面對這件事，這支籤的建議不是「放棄」，而是「先停下來，看清楚，再出發」。硬撐有時候不是堅持，而是一種繞遠路的方式。真正的應對，是先承認「這裡有一些我還沒搞清楚的地方」，然後帶著這個意識，去找到更適合的方式。\n\n生活裡很多時候，一支下籤反而是最貼心的禮物——它把你本來可能要繞很遠才能意識到的事，提前告訴了你。現在知道了，就有機會調整。\n\n願你在這次調整裡，找到更對的方向。願停下來的這一刻，成為下一段路真正出發的起點。前路漫漫，且行且寬心。祝好。',
    letterDefaultQuestion: '你心裡惦記的那件事',
    aboutResultTitle: '關於這次結果',
    aboutResultUpper: '抽到上籤的這一刻，心裡是鬆快的。但上籤真正想告訴你的，不是「你可以躺贏了」，而是「這個階段順勢而為，會格外省力」。把它當成一陣順風——帆要你自己揚，路要你自己走，風只是讓這段路輕鬆一點。',
    aboutResultMiddle: '中籤往往是三支籤裡最誠實的提醒——它不像上籤那樣讓人心花怒放，也不像下籤那樣讓人緊張。它只是平靜地告訴你：方向沒錯，但還差一點火候。這一點，恰恰是你現在最該補上的地方。',
    aboutResultLower: '抽到下籤，心裡多少會沉一下。但下籤不是在給你判刑，而是在把你遲早要面對、卻一直想繞開的那件事，提前擺到你面前。它像一盞燈，照的不是你的壞運氣，而是你還沒看清的那個角落。',
    takeawayTitle: '可以帶走的一句話',
    takeawayUpper: '上籤不是命運的綠燈，而是讓你更有底氣地邁出那一步——但路，終究要自己走。',
    takeawayMiddle: '中籤的智慧在於：它提醒你「還差一點」。這一點不是拿來焦慮的，是拿來給你方向的。',
    takeawayLower: '下籤不是一扇關上的門，而是提醒你：這扇門之外，還有更適合你的窗。',
    finalTitle: '最後',
    finalContent: '卦籤不會替你做決定，它只是把你心裡隱約知道、卻還不敢承認的事，輕輕放到了桌面上。看懂它，然後回到你的生活裡，繼續往前走。',
    understandYou: '我懂你',
    noAnxiety: '邊界提醒',
    youCanControl: '你可以掌控',
    worthLookingForward: '值得期待',
    understandUpper: '上籤是好事——但籤意真正的價值不在「吉」這個字上，而在「為什麼這個階段適合順勢而為」。把好運接住的同時，也別忘了看清哪些地方依然需要用心。',
    understandMiddle: '中籤往往是「最容易被忽略的提醒」——它不像上籤那樣讓人開心，也不像下籤那樣讓人緊張。但它的價值恰恰在於：它告訴你在哪些地方還可以做得更好。',
    understandLower: '抽到下籤的這一刻，心裡多少有些沉。但籤不是在詛咒你——它更像一個誠實的提醒者，把你遲早要面對的那件事，提前推到你面前。你現在最需要的不是害怕，而是看懂這支籤到底在提醒你什麼。',
    noAnxietyUpper: '把籤當成一面鏡子——它照出的不是你的命運，而是你當前的狀態。看得清，才能走得穩。吉不是躺贏的通行證，凶也不是放棄的理由。',
    noAnxietyLower: '下籤不是在判你「運氣不好」——它是在說：當前在某些方向上，需要你比平時更小心、更清醒。這不是「不行」，而是「需要換一種方式」。很多人抽了下籤後反而更順了——因為籤提醒了他們那些本來會忽略的風險。',
    controlContent: '現在最重要的不是把整支籤都解讀清楚——而是抓住那個最貼近你當前處境的提醒，先行動起來。哪怕只是調整一個習慣、做一次溝通、放下一份執念——動起來，籤的力量才算真正被你接住了。',
    worthContent: '一支籤的價值不在抽到它的那一刻——而在你帶著它的提醒去生活之後，回頭看時發現：原來那支籤真的說中了什麼。把籤當成一個善意的外援，而不是一個絕對的判決。',
    quoteTitle: '這支籤最值得記住的',
    quotefitTag: '適合截圖',
    quoteCoreTag: '籤的核心',
    quoteCoreText: '籤詩的核心不是吉凶——是「為什麼這個階段會有這樣的提醒」。讀懂這一層，比看懂「上中下」三個字值錢得多。',
    quoteUsageTag: '籤的正確用法',
    quoteUsageText: '求籤不是在問「命好不好」——而是在問「現在最該注意什麼」。把籤當成導航，而不是判決書。',
    quoteKeyTag: '如果你只記住一句',
    quoteKeyUpper: '這支籤不是在說「你不行」——它是在說：現在換一種方式，比硬撐更聰明。真正厲害的人，不是從不遇到下籤，而是每次都能從下籤裡找到正確的突破口。',
    quoteKeyMiddle: '中籤的智慧在於：它在提醒你「還差一點」。這一點不是讓你焦慮的，是讓你更有方向的。',
    quoteKeyLower: '上籤是宇宙給你的綠燈——但綠燈不是讓你閉眼衝，而是讓你更有信心地走下去。',
    memberTitle: '解鎖會員 · 查看籤詩全解與流年對照',
    memberSubtitle: '當前僅展示基礎籤級與吉凶判斷。會員版將呈現籤詩全解、各方面運勢詳析與流年對照推演。',
    memberBenefit1: '籤詩全解與典故溯源深度解析',
    memberBenefit2: '各方面運勢詳析與吉祥方位推演',
    memberBenefit3: '流年運勢疊加與應期時間對照',
    memberBenefit4: '求籤歷史存檔與趨勢對比分析',
    memberBenefit5: '每月領取更多靈力值',
    memberBenefit6: '最低只需$1.29/月',
    memberAction: '立即解鎖完整籤詩推演',
  },
};